(function (root) {
  'use strict';
  var DAY = 86400000;
  function pad(n) { return String(n).padStart(2, '0'); }
  function key(d) { return d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()); }
  function utc(k) { return new Date(k + 'T12:00:00Z'); }
  function valid(k) {
    return /^\d{4}-\d{2}-\d{2}$/.test(k) && !isNaN(utc(k)) && utc(k).toISOString().slice(0,10) === k;
  }
  function parse(raw) {
    var dates = [], invalid = [];
    String(raw || '').split(/[\s,;]+/).filter(Boolean).forEach(function(k) {
      if (valid(k)) { if (dates.indexOf(k) < 0) dates.push(k); }
      else invalid.push(k);
    });
    return {dates: dates.sort(), invalid: invalid};
  }
  function shift(k, days) {
    if (!valid(k)) throw new Error('Invalid calendar date');
    return new Date(utc(k).getTime() + days*DAY).toISOString().slice(0,10);
  }
  function nowParts(instant, zone) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: zone || 'America/New_York', year:'numeric', month:'2-digit', day:'2-digit',
      hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'
    }).formatToParts(instant || new Date()).forEach(function(p){parts[p.type] = p.value;});
    return {key:parts.year+'-'+parts.month+'-'+parts.day, hour:Number(parts.hour)%24,
      minute:Number(parts.minute), second:Number(parts.second)};
  }
  function wallNow(zone, instant) {
    var p = nowParts(instant,zone), d = p.key.split('-').map(Number);
    return new Date(d[0],d[1]-1,d[2],p.hour,p.minute,p.second);
  }
  function format(k, short) {
    return new Intl.DateTimeFormat('en-US', {timeZone:'UTC',weekday:short?'short':'long',
      month:short?'short':'long',day:'numeric'}).format(utc(k));
  }
  function create(raw) {
    var parsed = parse(raw), closed = parsed.dates;
    function isClosed(k) { return closed.indexOf(k) >= 0; }
    function production(k, weekdays) {
      return valid(k) && (weekdays || [1,2,3,4,5]).indexOf(utc(k).getUTCDay()) >= 0 && !isClosed(k);
    }
    function next(k, weekdays, include) {
      for(var i=include?0:1;i<=3660;i++) {
        var candidate=shift(k,i);
        if (production(candidate,weekdays)) return candidate;
      }
      return null;
    }
    function add(k, count, weekdays) {
      var result=k;
      for(var i=0;i<count;i++) {result=next(result,weekdays);if(!result)return null;}
      return result;
    }
    function notice(today, lead) {
      var n = Math.max(0,Math.min(90,Number(lead)||0));
      var nearest=closed.find(function(k){return k>=today && k<=shift(today,n);});
      return nearest ? {date:nearest,today:nearest===today,label:format(nearest)} : null;
    }
    return {dates:closed,invalid:parsed.invalid,isClosed:isClosed,
      isProduction:production,nextProduction:next,addProductionDays:add,notice:notice};
  }
  var api={create:create,parse:parse,valid:valid,key:key,shift:shift,format:format,
    nowParts:nowParts,wallNow:wallNow};
  root.DIYCalendarCore=api;
  if(typeof module==='object' && module.exports) module.exports=api;
})(typeof window==='object'?window:globalThis);
